import imageDefault from "../rsc/img/image-default.png";

export let handleImgLoadError = (e) => {
    e.target.onerror = null;
    e.target.src = imageDefault;
};